import "./power.css";

export default function ResultScreen({ result, onRetry }) {
  const isCorrect = result.isCorrect;

  return (
    <div className="result-container">

      {/* GREEN HEADER */}
      <div className={`result-header ${isCorrect ? "correct" : "wrong"}`}>
        <h2>{isCorrect ? "Correct" : "Wrong"}</h2>
      </div>

      {/* CHECK ICON */}
      <div className="check-circle">
        {isCorrect ? "✔" : "✖"}
      </div>

      {/* CARD */}
      <div className="result-card">

        <div className="card-title">
          {result?.config?.exerciseType}
        </div>

        <div className="row">
          <span>Power exercise for</span>
          <span>+ {result?.addValue}</span>
        </div>

       <div className="row">
  <span>Start From</span>
  <span>{result.startValue}</span>
</div>

        <div className="row">
          <span>Time</span>
          <span>
            {result?.config?.time === "1 Minute" ? "60 seconds" : "120 seconds"}
          </span>
        </div>

        <div className="row">
          <span>Answer</span>
          <span>{result?.userAnswer}</span>
        </div>

        <div className="row">
          <span>Count</span>
          <span>{result?.count}</span>
        </div>

      </div>

      {/* BUTTON */}
      <button className="start-btn" onClick={onRetry}>
        Try again
      </button>

    </div>
  );
}